export const LANGUAGE = '[Language]';

const types = {
  CHANGE_LOCALE: `${LANGUAGE} CHANGE_LOCALE`
};

export default types;
